const Favorite = () => {
  return (
    <svg width="27" height="27" viewBox="0 0 23 23" fill="inherit" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5177 0.680762L15.1484 6.23632C15.2627 6.56965 15.6059 6.79187 15.949 6.90298L21.8965 7.79187C22.9259 7.79187 23.269 8.90298 22.5828 9.56965L18.2365 13.903C18.0078 14.1252 17.8934 14.5696 17.8934 14.903L18.9228 20.903C19.0371 21.7919 18.1221 22.5697 17.3215 22.1252L11.9459 19.2363C11.6027 19.0141 11.2596 19.0141 10.9165 19.2363L5.54085 22.1252C4.74022 22.5697 3.71084 21.903 3.93959 20.903L4.96897 14.903C5.08335 14.5696 4.8546 14.1252 4.62585 13.903L0.279584 9.56965C-0.292292 8.90298 0.0508334 7.79187 0.965836 7.68076L6.91335 6.79187C7.25648 6.79187 7.5996 6.45854 7.71398 6.12521L10.3446 0.569651C10.9165 -0.208127 12.0602 -0.208127 12.5177 0.680762Z" />
    </svg>
  );
};

export default Favorite;
